import ViewerPage from './viewer-page/ViewerPage'
import LoadingPage from './loading-page/LoadingPage';
import {lazy} from 'react'

const SubscribePage=lazy(()=>import('./subscribe-page/SubscribePage'))
const PrivacyPolicyPage=lazy(()=>import("./privacy-policy-page/PrivacyPolicyPage"))
const TermsOfUsePage=lazy(()=>import("./terms-of-use-page/TermsOfUsePage"))
const FeedbackPage=lazy(()=>import('./feedback/FeedbackPage'))
const TestCasePage=lazy(()=>import('./test-case/TestCasePage'))
const Share=lazy(()=>import('./Share/SharePage'))
const EsignToolsPage=lazy(()=>import('./esignTools/EsignToolsPage'))
const ESignCNEvidenceToolPage=lazy(()=>import('./eSignCNEvidenceTool/ESignCNEvidenceToolPage'))
const ESignCNAuditTrail=lazy(()=>import('./eSignCNAuditTrail/index'))
const LinkResourceForCanvas =lazy(()=>import('./CanvasPlatform/index'))
const MissFileTip = lazy(()=>import('Components/header/MissFileTip'));

export {
    LoadingPage,
    ViewerPage,
    SubscribePage,
    PrivacyPolicyPage,
    TermsOfUsePage,
    FeedbackPage,
    EsignToolsPage,
    ESignCNEvidenceToolPage,
    //some test case
    TestCasePage,
    Share,
    LinkResourceForCanvas,
    MissFileTip,
    ESignCNAuditTrail,
};
